var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50","width":_vm.size,"height":_vm.size}},[_c('circle',{staticClass:"path",style:({stroke: _vm.color}),attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }